import styled, { css } from 'styled-components';

export const StyledIcon = styled.span<{ width: number | string; height: number | string }>`
    ${({ width, height }) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: ${width}px;
        height: ${height}px;
    `}
`;
